import { initLatestCPTBlock } from './utils/latest-cpt/frontend';

initLatestCPTBlock({
	containerSelector: '.wp-block-welko-latest-essais',
	blockPrefix: 'wp-block-welko-latest-essais',
	ajaxActionFilter: 'welko_latest_essais_term_filter',
	ajaxActionLoadmore: 'welko_latest_essais_loadmore',
});
